import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

export const Customer = () => {
    const { values, setFieldValue } = useContext(FormContext);
    const { dispatchLocationId } = values;

    const { data, isLoading } = useQuery({
        queryKey: ['customersByDispatchLocation', dispatchLocationId],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.customersByDispatchLocation(dispatchLocationId)),
        enabled: !!dispatchLocationId,
    });

    return (
        <ValidatedSelect
            id="companyId"
            name="companyId"
            label="Customer"
            options={data}
            isLoading={isLoading}
            isDisabled={!dispatchLocationId}
            required
            error="A customer is required."
            onChange={() => {
                setFieldValue('contractId', null);
                setFieldValue('projectId', null);
            }}
        />
    );
};
